import { FilterOptionTypes, IFilter } from "../models/filter";
import { ISelectedNode } from "../models/node";
import { IAction, IAsyncState } from "./action";
export var actionTypes = {
    loadScopeNames: 'reportBuilder/LOAD_SCOPE_NAMES',
    scopeNamesLoaded: 'reportBuilder/SCOPE_NAMES_LOADED',
    loadDataModelNames: 'reportBuilder/LOAD_DATAMODEL_NAMES',
    dataModelNamesLoaded: 'reportBuilder/DATAMODEL_NAMES_LOADED',
    loadDataModelNodes: 'reportBuilder/LOAD_DATAMODEL_NODES',
    dimensionsLoaded: 'reportBuilder/DIMENSIONS_LOADED',
    setSelectedDimensions: 'reportBuilder/SET_SELECTED_DIMENSIONS',
    metricsLoaded: 'reportBuilder/METRICS_LOADED',
    setSelectedMetrics: 'reportBuilder/SET_SELECTED_METRICS',
    addOption: 'reportBuilder/ADD_OPTION',
    selectOption: 'reportBuilder/SELECT_OPTION',
    unselectOption: 'reportBuilder/UNSELECT_OPTION',
    compatibilityChecked: 'reportBuilder/COMPATIBILITY_CHECKED',
    sortOrder: 'reportBuilder/SORT_ORDER',
    sortEnd: 'reportBuilder/SORT_END',
    addFilter: 'reportBuilder/ADD_FILTER',
    filtersLoaded: 'reportBuilder/FILTERS_LOADED',
    removeFilter: 'reportBuilder/REMOVE_FILTER',
    setFilters: 'reportBuilder/SET_FILTERS',
    selectFilterOption: 'reportBuilder/SELECT_FILTER_OPTION',
    changeFilterInput: 'reportBuilder/CHANGE_FILTER_INPUT',
    changeLimitRowsTo: 'reportBuilder/CHANGE_LIMIT_ROWS_TO',
    changeStartWithRow: 'reportBuilder/CHANGE_START_WITH_ROW',
    loadReportRequest: 'reportBuilder/LOAD_REPORT_REQUEST',
    generateReportRequest: 'reportBuilder/GENERATE_REPORT_REQUEST',
    reportRequestGenerated: 'reportBuilder/REPORT_REQUEST_GENERATED',
    loadSelect: 'reportBuilder/LOAD_SELECT',
    selectLoaded: 'reportBuilder/SELECT_LOADED',
    loadDataOptimized: 'reportBuilder/LOAD_DATA_OPTIMIZED',
    dataOptimizedLoaded: 'reportBuilder/DATA_OPTIMIZED_LOADED',
    loadDataFull: 'reportBuilder/LOAD_DATA_FULL',
    dataFullLoaded: 'reportBuilder/DATA_FULL_LOADED',
    loadCsvFile: 'reportBuilder/LOAD_CSV_FILE',
    csvFileLoaded: 'reportBuilder/CSV_FILE_LOADED',
    setTranslations: 'reportBuilder/SET_TRANSLATIONS',
    expandReportOptions: 'reportBuilder/EXPAND_REPORT_OPTIONS',
};
export function loadScopeNames(payload) {
    return {
        type: actionTypes.loadScopeNames,
        payload: payload,
    };
}
export function scopeNamesLoaded(payload) {
    return {
        type: actionTypes.scopeNamesLoaded,
        payload: payload,
    };
}
export function loadDataModelNames(payload) {
    return {
        type: actionTypes.loadDataModelNames,
        payload: payload,
    };
}
export function dataModelNamesLoaded(payload) {
    return {
        type: actionTypes.dataModelNamesLoaded,
        payload: payload,
    };
}
export function loadDataModelNodes(payload) {
    return {
        type: actionTypes.loadDataModelNodes,
        payload: payload,
    };
}
export function dimensionsLoaded(payload) {
    return {
        type: actionTypes.dimensionsLoaded,
        payload: payload,
    };
}
export function addDataModel(payload) {
    return {
        type: actionTypes.addOption,
        payload: payload,
    };
}
export function selectDataModel(payload) {
    return {
        type: actionTypes.selectOption,
        payload: payload,
    };
}
export function unselectDataModel(payload) {
    return {
        type: actionTypes.unselectOption,
        payload: payload,
    };
}
export function compatibilityChecked(payload) {
    return {
        type: actionTypes.compatibilityChecked,
        payload: payload,
    };
}
export function sortOrder(payload) {
    return {
        type: actionTypes.sortOrder,
        payload: payload,
    };
}
export function sortEnd(payload) {
    return {
        type: actionTypes.sortEnd,
        payload: payload,
    };
}
export function setSelectedDimensions(payload) {
    return {
        type: actionTypes.setSelectedDimensions,
        payload: payload,
    };
}
export function metricsLoaded(payload) {
    return {
        type: actionTypes.metricsLoaded,
        payload: payload,
    };
}
export function setSelectedMetrics(payload) {
    return {
        type: actionTypes.setSelectedMetrics,
        payload: payload,
    };
}
export function addFilter() {
    return {
        type: actionTypes.addFilter,
    };
}
export function filtersLoaded(payload) {
    return {
        type: actionTypes.filtersLoaded,
        payload: payload,
    };
}
export function selectFilterOption(payload) {
    return {
        type: actionTypes.selectFilterOption,
        payload: payload,
    };
}
export function changeFilterInput(payload) {
    return {
        type: actionTypes.changeFilterInput,
        payload: payload,
    };
}
export function removeFilter(payload) {
    return {
        type: actionTypes.removeFilter,
        payload: payload,
    };
}
export function setFilters(payload) {
    return {
        type: actionTypes.setFilters,
        payload: payload,
    };
}
export function changeLimitRowsTo(payload) {
    return {
        type: actionTypes.changeLimitRowsTo,
        payload: payload,
    };
}
export function changeStartWithRow(payload) {
    return {
        type: actionTypes.changeStartWithRow,
        payload: payload,
    };
}
export function loadReportRequest(payload) {
    return {
        type: actionTypes.loadReportRequest,
        payload: payload,
    };
}
export function generateReportRequest() {
    return {
        type: actionTypes.generateReportRequest,
    };
}
export function reportRequestGenerated(payload) {
    return {
        type: actionTypes.reportRequestGenerated,
        payload: payload,
    };
}
export function loadSelect(payload) {
    return {
        type: actionTypes.loadSelect,
        payload: payload,
    };
}
export function selectLoaded(payload) {
    return {
        type: actionTypes.selectLoaded,
        payload: payload,
    };
}
export function loadDataOptimized(payload) {
    return {
        type: actionTypes.loadDataOptimized,
        payload: payload,
    };
}
export function dataOptimizedLoaded(payload) {
    return {
        type: actionTypes.dataOptimizedLoaded,
        payload: payload,
    };
}
export function loadDataFull(payload) {
    return {
        type: actionTypes.loadDataFull,
        payload: payload,
    };
}
export function dataFullLoaded(payload) {
    return {
        type: actionTypes.dataFullLoaded,
        payload: payload,
    };
}
export function loadCsvFile(payload) {
    return {
        type: actionTypes.loadCsvFile,
        payload: payload,
    };
}
export function csvFileLoaded(payload) {
    return {
        type: actionTypes.csvFileLoaded,
        payload: payload,
    };
}
export function setTranslations(payload) {
    return {
        type: actionTypes.setTranslations,
        payload: payload,
    };
}
export function expandReportOptions() {
    return {
        type: actionTypes.expandReportOptions,
    };
}
